
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Operation } from '../operation/operation';
import { Document } from './document';
import { Apollo } from 'apollo-angular';

const DocumentsQuery = require('./gql/documents.query.gql');
const DocumentQuery = require('./gql/document.query.gql');
const createDocumentMutation = require('./gql/create-document.mutation.gql');
const updateDocumentMutation = require('./gql/update-document.mutation.gql');
const deleteDocumentMutation = require('./gql/delete-document.mutation.gql');

/**
 * Service to manage documents
 */
@Injectable()
export class DocumentService {

  constructor(private apollo: Apollo) { }

  documents(operation_id: string, revision_id: string): Observable<Operation> {
    return this.apollo
      .query({
        query: DocumentsQuery,
        variables: {
          operation_id,
          revision_id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => new Operation(result.data['operation'])));
  }

  document(operation_id: string, revision_id: string, id: string): Observable<Operation> {
    return this.apollo
      .query({
        query: DocumentQuery,
        variables: {
          operation_id,
          revision_id,
          id
        }
      }).pipe(
      map(result => new Operation(result.data['operation'])));
  }

  create(operation_id: string, revision_id: string, document: Document): Observable<Document> {
    return this.apollo
      .mutate({
        mutation: createDocumentMutation,
        variables: {
          operation_id,
          revision_id,
          input: document.toCreateDocumentInput()
        }
      }).pipe(
      map(result => new Document(result.data['createDocument'])));
  }

  update(operation_id: string, revision_id: string, id: string, document: Document): Observable<Document> {
    return this.apollo
      .mutate({
        mutation: updateDocumentMutation,
        variables: {
          operation_id,
          revision_id,
          id,
          input: document.toUpdateDocumentInput()
        }
      }).pipe(
      map(result => new Document(result.data['updateDocument'])));
  }

  delete(operation_id: string, revision_id: string, id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteDocumentMutation,
        variables: {
          operation_id,
          revision_id,
          id
        }
      }).pipe(
      map(result => result.data['deleteDocument']));
  }
}